import Slider from "react-slick";
import ZoomImageSection from "./ZoomImageSection";
import { get_property_settings } from "../../../../../../../Component/Helper";

function ZoomSliderSection({imageRootPath, allThumbImages, currentSlide}) {
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: currentSlide,
      };

      const cdn = get_property_settings("cdn")
     
      return (
        <div className="slider-container">
          <Slider {...settings}>
            {
                allThumbImages.map(img => {
                  const imagepath = img.includes(".mp4") ? `${cdn}uploads/design_video/${img}` : `${imageRootPath}${img}`
                  return <ZoomImageSection imagepath={imagepath} key={img}/>
                })
            }
            
          </Slider>
        </div>
      );
}

export default ZoomSliderSection;